import { MulticastDelegate, UpdateReflectionProbesMessage } from "flavr-common";
import { RendererSystem } from "../renderer/RendererSystem";
export class ReflectionProbeSystem extends RendererSystem {
    constructor(rendererModule) {
        super(rendererModule, "ReflectionProbeSystem");
        this.onUpdateReflectionProbeDelegate = new MulticastDelegate();
        this.handleUpdateReflectionPropesMessage = () => {
            this.onUpdateReflectionProbeDelegate.invoke();
        };
        this.renderer.getConnection().subscribeByType(UpdateReflectionProbesMessage, this.handleUpdateReflectionPropesMessage);
    }
}
